import { useSelector } from 'react-redux';
import {
  getQrAttendanceCount,
  getQrAttendanceCountUpdatedAt,
} from 'store/classroomAttendance';

export const useQrAttendanceCount = (sessionId) =>
  useSelector(getQrAttendanceCount(sessionId));

export const useQrAttendanceCountUpdatedAt = (sessionId) =>
  useSelector(getQrAttendanceCountUpdatedAt(sessionId));
